/**
 * The sentences of a text: a new one starts after . ! or ? and a space, at a capital letter or a digit, and not
 * after a common abbreviation ("Ca. 20 cellen", "bijv. Rode", "T. Rex"; ADR-091 round 1 M4); each with a letter
 * in it. Shared by the world package's `uiterlijk` check and the fact sheet's misconception lines.
 */
export const sentencesOf = (text) => text
    .split(/(?<!(?:^|[\s(])(?:[Cc]a|[Bb]ijv|[Bb]v|[Bb]\.v|[Oo]\.a|[Dd]\.w\.z|[Ee]nz|[Nn]r|[Oo]ng|[Rr]esp|[Vv]gl|[Zz]gn|\p{Lu})\.)(?<=[.!?])\s+(?=["'“‘(]?[\p{Lu}\p{N}])/u)
    .map((sentence) => sentence.trim())
    .filter((sentence) => /\p{L}/u.test(sentence));
//# sourceMappingURL=sentences.js.map